
import React, { useState } from "react";
import { StyledHorLayoutGrid, StyledVerLayoutGrid } from "./styled";


/**
 * fiddle for dealing with rotation: https://jsfiddle.net/wunderbart/w1hw5kv1/
 */

export const ImageReposManager = ({
  fullWidthOrFullHeightImg,
  wrapperRef,
  renderedImageRef,
  setUnderEditImageData,
}) => {

  

  const repositionDirection =
    fullWidthOrFullHeightImg === "fullWidth"
      ? "vertical"
      : fullWidthOrFullHeightImg === "fullHeight" && "horizontal"; //temp

  


  const getRenderedImageHeight = (imgRef) => imgRef.current?.offsetHeight;
  const getRenderedImageWidth = (imgRef) => imgRef.current?.offsetWidth;

  const [initialY, setInitialY] = useState(null);
  const [yOffset, setYOffset] = useState(0);
  const [initialX, setInitialX] = useState(null);
  const [xOffset, setXOffset] = useState(0);
  const [mouseIsDown, setMouseIsDown] = useState(false);

  const onMouseDown = (e) => {
    setMouseIsDown(true);
    let clientX = e.touches ? e.touches[0].clientX : e.clientX;
    let clientY = e.touches ? e.touches[0].clientY : e.clientY;
    repositionDirection === "horizontal"
      ? setInitialX(clientX - xOffset)
      : setInitialY(clientY - yOffset);

    /*
    If this function has been triggered by a touch event,
    then, temp disable html scroll, else the image reposition 'drag' wont work.

    This ofcourse doesnt hold true for desktop.
    */
    // if(ops.isTouchStart){
    //   document //this is so that on mobile repos works, else, it ends up scrolling the page
    //   .getElementsByTagName('html')[0]
    //   .setAttribute('style', 'overflow: hidden')  
    // // }
  };

  const onMouseUp = () => {
    setMouseIsDown(false);
    // document.getElementsByTagName('html')[0].removeAttribute('style')
  };

  const onMouseOver = () => setMouseIsDown(false);

  const repositionVertical = (e) => {
    if (mouseIsDown === true) {
      let clientY = e.touches ? e.touches[0].clientY : e.clientY;
      let currentY = clientY - initialY;
      let renderedImgHeight = getRenderedImageHeight(renderedImageRef);
      // (imgHeight * wrapperRef.current.clientWidth) / imgWidth; //actual rendered height of image
      let wrapperHeight = wrapperRef.current.clientHeight;
      if (currentY <= 0 && currentY >= -(renderedImgHeight - wrapperHeight)) {
        setYOffset(currentY);
        setUnderEditImageData((prev) => ({
          ...prev,
          cropY: (currentY / renderedImgHeight) * 100,
        }));
        // setImgPosY((currentY / renderedImgHeight) * 100); //finally set the y-translate in percentage so that it works in different container sizes
      }
    }
  };

  const repositionHorizontal = (e) => {
    if (mouseIsDown === true) {
      let clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let currentX = clientX - initialX;
      let renderedImgWidth = getRenderedImageWidth(renderedImageRef);
      // (imgWidth * wrapperRef.current.clientHeight) / imgHeight; //actual rendered width of image
      let wrapperWidth = wrapperRef.current.clientWidth;
      if (currentX <= 0 && currentX >= -(renderedImgWidth - wrapperWidth)) {
        setXOffset(currentX);
        setUnderEditImageData((prev) => ({
          ...prev,
          cropX: (currentX / renderedImgWidth) * 100,
        }));
        // setImgPosX((currentX / renderedImgWidth) * 100); //finally set the x-translate in percentage so that it works in different container sizes
      }
    }
  };

  return (
    <div>
      <div>
        <StyledHorLayoutGrid />
        <StyledVerLayoutGrid />
      </div>
      <div
        style={{
          top: "0",
          cursor: "move",
          position: "absolute",
          width: "100%",
          height: "100%",
          touchAction: 'none' //very important, ensures that touch drag doesnt scroll the page
        }}
        onMouseDown={(e) => onMouseDown(e)}
        onTouchStart={(e) => onMouseDown(e)}
        onMouseUp={onMouseUp}
        onTouchEnd={onMouseUp}
        onMouseOver={onMouseOver}
        onMouseMove={(e) =>
          repositionDirection === "vertical"
            ? repositionVertical(e)
            : repositionHorizontal(e)
        }
        onTouchMove={(e) => {
          
          e.preventDefault();
          repositionDirection === "vertical"
            ? repositionVertical(e)
            : repositionHorizontal(e);
        }}
      ></div>
    </div>
  );
}